import axios from "axios"
import { saveAs } from "file-saver"

const request = (method, path, data, responseType) => axios({ method, url: `/api/accounting/alibey-bills${path}`, data, responseType,
  timeout: 30000, headers: { Authorization: localStorage.getItem("token") } }).then(response => response.data)

export default {
  alibeyBills: {
    fetch: () => request("get", "/"),
    create: (id, data) => request("post", `/${encodeURIComponent(id)}/invoice`, data),
    status: (id, data) => request("put", `/${encodeURIComponent(id)}/status`, data),
    remove: (id, data) => request("delete", `/${encodeURIComponent(id)}`, data),
    async download(id, number) {
      const blob = await request("get", `/${encodeURIComponent(id)}/pdf`, null, "blob")
      const filename = `Alibey_${number}`
      if (window.flutter_inappwebview) {
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onerror = () => reject(new Error("Die PDF-Datei konnte nicht gelesen werden."))
          reader.onload = () => resolve(String(reader.result).split(",")[1])
          reader.readAsDataURL(blob)
        })
        await window.flutter_inappwebview.callHandler("blobToBase64Handler", base64, "pdf", filename)
      } else saveAs(blob, `${filename}.pdf`)
    },
  },
}
